<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { AppInput } from '@shared/ui/inputs'
import { NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalCustomerKidCreate } from '../../model/modal-customer-kid-create.hook'

defineOptions({
  name: 'ModalCustomerKidCreate',
})

const {
  refIsOpen,
  refIsLoading,
  refName,
  refIsNameInvalid,
  gradeOptions,
  disciplineOptions,
  setName,
  setGrade,
  setDiscipline,
  closeModal,
  submit,
} = useModalCustomerKidCreate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Add new kid"
    @click:overlay="closeModal"
  >
    <div class="modal-customer-kid-create">
      <AppInput
        name="kid_name"
        label="Name *"
        placeholder="Enter kid name"
        :model-value="refName"
        :state="refIsNameInvalid ? 'error' : 'static'"
        @update:model-value="setName"
      />
      <NativeSelect
        name="discipline_grade"
        label="Grade"
        :options="gradeOptions"
        @change="setGrade"
      />
      <NativeSelect
        name="discipline_discipline"
        label="Discipline"
        :options="disciplineOptions"
        @change="setDiscipline"
      />
    </div>

    <template #controls>
      <BtnPrimary
        text="Create"
        color="emerald"
        :disabled="refIsLoading"
        @click="submit"
      />
      <BtnSecondary
        text="Cancel"
        :disabled="refIsLoading"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCustomerKidCreate.scss" />
